














import Vue from 'vue'
import Analytics from '@/services/Analytics'
import { mapGetters } from 'vuex'
import tenantNavMixin from '@/mixins/tenant-nav-mixin'
import Tenant from '@/types/Tenant.interface'
export default Vue.extend({
    mixins: [tenantNavMixin],
    mounted() {
        //  Create a new tenant, based on user's selected properties
        this.tenantCreate()
    },
    data() {
        return {
            //  The newly created tenant
            newTenant: null,
            //  Indicates that the new tenant is being created
            waitingForTenant: true
        }
    },
    computed: {
        ...mapGetters(['token', 'user']),
        // icpQuery(): object {
        //     //  Grab our company size query param
        //     const companySize = this.$route.query.companySize

        //     //  Grab our industry query param
        //     const industry = this.$route.query.industry

        //     //  Grab our team size query param
        //     const teamSize = this.$route.query.teamSize

        //     //  grab our reach query param
        //     const reach = this.$route.query.reach

        //     //  Create our ICP object
        //     return {
        //         companySize: companySize,
        //         industry: industry,
        //         teamSize: teamSize,
        //         reach: reach
        //     }
        // },
        // icpSelections(): object {
        //     //  Grab our ICP data from the store
        //     const icpData = this.$store.getters.icpData

        //     //  Grab our icpQuery
        //     const query = this.icpQuery

        //     //  If our query doesn't exist, return empty object (so spread doesn't break)
        //     if (!query) return {}

        //     //  Else, match our queries to the data
        //     const selections = {
        //         companySize: icpData.companySize[query.companySize].value,
        //         industry: icpData.industry[query.industry].value,
        //         teamSize: icpData.teamSize[query.teamSize].value,
        //         reach: icpData.reach[query.reach].value
        //     }

        //     //  Retun our selections
        //     return selections
        // },
        priceQuery(): string {
            if (this.$route.query.price) {
                return this.$route.query.price
            }
            return null
        }
    },
    methods: {
        isIntuitAppstore(): boolean {
            //  We know this registration is from intuit's appstore if the method is set
            return this.$route.query.method === 'subscribeFromAppstore'
        },
        onConditionMet(): void {
            //  Check if both wait conditions have been met
            const isReady = !this.waitingForTenant

            //  If the conditions have NOT been met, do nothing
            if (!isReady) return

            //  If this registration is coming from intuit's appstore, we have special handling
            if (this.isIntuitAppstore()) return this.subscribeFromAppstore()
            if (this.$route.query.provider === 'xero') {
                return (window.location.href = this.xeroConnectLink())
            }
            // Else, go to the admin's message channel in the newly created tenant
            // Set path as either the goto param if present or set query to displayPhone after registration
            this.goToTenant(this.newTenant.id, this.$route.query.goto || '/home')
        },
        reportAnalytics(tenant: Tenant): void {
            //  Lambda to convert keys to snake case for segment
            // const camelToSnake = (key: string) => {
            //     return key.replace(/([A-Z])/g, '_$1').toLowerCase()
            // }

            // //  Grab our ICP data
            // const icpData = this.icpSelections

            // //  Container for our new object
            // const newIcpData = {}

            // //  Our new icp data is keys converted to snake
            // for (var key in icpData) {
            //     newIcpData[camelToSnake(key)] = icpData[key]
            // }

            //  Create our properties for the report
            const data = {
                // ...newIcpData,
                tenant_id: tenant.id,
                mobilephone: this.user.mobilephone,
                chosen_plan: this.$store.getters.productTier,
                client_id: localStorage.getItem('clientID'),
                email: this.user.email,
                paying_user: false,
                organization_name: tenant.company_name
            }

            //  Report to Segment
            Analytics.track('OnboardingStarted', data)

            //  Do an extra group call here for MCS
            window.analytics.group(tenant.id, {
                // ...newIcpData,
                name: tenant.company_name
            })
        },
        subscribeFromAppstore(): void {
            //  Assemble the direct connect url
            const url = `${this.$store.getters.api}/qbo/directConnectToQbo`

            //  Redirect the user to connect to quickbooks
            window.location.href = url
        },
        async tenantCreate(): Promise<void> {
            //  If this user already has a tenant, do nothing
            if (this.$store.getters.tenant) return

            //  Assemble a new tenant payload from user's selected props
            const payload = {
                company_name: this.user.organization_name || this.user.email,
                price: this.priceQuery,
                referred: this.$route.query.referralCode != null,
                // ...this.icpSelections
            }

            //  Create a new tenant
            const tenant = await this.$store.dispatch('tenantPost', payload)

            //  If no tenant was created, do nothing
            if (!tenant) return

            //  At this point the user has already been created, we just need to fetch their updated tenant memberships
            //  We use 'usersFind' here instead of 'authUserGet' because we want the user's person to be available
            const user = await this.$store.dispatch('usersFind', this.user.id)

            //  Update the auth user
            this.$store.commit('authUserSet', user)

            //  Fetch the tenant's subscription before redirecting into the app where we use the SubscriptionGuard for some routes
            await this.$store.dispatch('subscriptionGet')

            //  Report "OnboardingStarted" (we wait until here so we have subscription info available)
            this.reportAnalytics(tenant)

            //  Save tenant and person id for later (we need them to nav correctly)
            this.newTenant = tenant

            //  Tenant creation is complete, so update waiting condition
            this.waitingForTenant = false

            //  Handle the event when a condition has been completed
            this.onConditionMet()
        },
        xeroConnectLink(): string {
            const base = `${process.env.VUE_APP_URL_API}`
            return `${base}/xero/oauth/connect/redirect?tenant_id=${this.newTenant.id}&auto_sync=true`
        }
    }
})
